import { NavLink, Outlet } from 'react-router-dom';
import { Users, Shield, Building2, Plug, ScrollText, Sliders } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { SectionHeader } from '@/components/ui/Card';
import { cn } from '@/lib/utils';

const SETTINGS_NAV = [
  { to: '/settings/users',        label: 'Users',         icon: Users,       ownerOnly: true },
  { to: '/settings/roles',        label: 'Roles',         icon: Shield,      ownerOnly: false },
  { to: '/settings/company',      label: 'Company',       icon: Building2,   ownerOnly: true },
  { to: '/settings/integrations', label: 'Integrations',  icon: Plug,        ownerOnly: true },
  { to: '/settings/audit',        label: 'Audit Log',     icon: ScrollText,  ownerOnly: true },
  { to: '/settings/preferences',  label: 'Preferences',   icon: Sliders,     ownerOnly: false },
];

export function SettingsLayout() {
  const { user } = useAuth();
  const isOwner = user?.role === 'owner';
  const visible = SETTINGS_NAV.filter((i) => isOwner || !i.ownerOnly);

  return (
    <div className="space-y-8">
      <SectionHeader
        kicker="Settings"
        title="Portal administration."
        description="Manage who has access, configure integrations, customize defaults, and review activity."
      />

      <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-8">
        {/* Left rail */}
        <nav className="space-y-0.5 lg:sticky lg:top-24 self-start">
          {visible.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'group flex items-center gap-3 px-3 h-10 rounded-sm text-sm transition-colors duration-150',
                    isActive
                      ? 'bg-bg-panel text-text border-l-2 border-brass-400 pl-[10px]'
                      : 'text-text-muted hover:text-text hover:bg-bg-panel/50',
                  )
                }
              >
                <Icon size={15} className="shrink-0" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        {/* Content */}
        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
